import _ from "lodash";
import { useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useBurn = () => {
    const [message, setMessage] = useState("");
    const [waitConfirmBurn, setWaitConfirmBurn] = useState(false);
    const tokenAddress = localStorage.getItem("tokenContractAddress");

    const callBurn = async (
        signer: ethers.ContractRunner | null | undefined,
        amount: any
    ) => {
        try {
            setWaitConfirmBurn(true);

            const burn = new ethers.Contract(
                tokenAddress || '',
                ERC20ABI.abi,
                signer
            );

            const tx = await burn.burn(
                ethers.parseUnits(amount, 18)
            );

            setWaitConfirmBurn(false);
            return { err: "", tx: tx };
        } catch (err: any) {
            const errs = _.get(err, "error.message");
            const msgs = _.get("", errs);
            if (err.code === "ACTION_REJECTED") {
                setWaitConfirmBurn(false);
                setMessage("User rejected transaction");
                return { err: "User rejected transaction", tx: "" };
            } else {
                if (msgs === undefined) {
                    setWaitConfirmBurn(false);
                    setMessage(err.message.split("(")[0] || "");
                    return { err: err.message.split("(")[0] || "", tx: "" };
                } else {
                    setWaitConfirmBurn(false);
                    setMessage(msgs.msg);
                    return { err: msgs.msg, tx: "" };
                }
            }
        }
    };

    return {
        onBurn: callBurn,
        waitConfirmBurn: waitConfirmBurn,
        messageError: message,
    };
};
